<template>
    <div :class="['cb-wizard', getItem('wizardStep')]">
        <ChatVersionSelection  v-if="getItem('wizardStep') =='version-selection'"></ChatVersionSelection>
        <ChatLanguageSelection  v-if="getItem('wizardStep')=='language-selection'"></ChatLanguageSelection>
        <ChatIndexingState v-if="getItem('wizardStep')=='indexing-loading'"></ChatIndexingState>
        <ChatFaqSelection  v-if="getItem('wizardStep')=='faq-selection'"></ChatFaqSelection>
        <div v-if="showNextButton" :class="['cb-step-action', getItem('wizardStep'),  (Object.keys(getItem('versions')).length==1)? 'one-version':'']">
            <div :class="['cb-btn-next', nextStep =='' ? 'disabled': '']" @click="handleNextClick">{{ $t('frm_next') }}</div>
        </div>
    </div>
</template>
<script>
    import ChatVersionSelection from './ChatVersionSelection';
    import ChatLanguageSelection from './ChatLanguageSelection';
    import ChatFaqSelection from './ChatFaqSelection';
    import ChatIndexingState from './ChatIndexingState';
    import { createNamespacedHelpers } from 'vuex';
    const { mapActions: aiChatMapActions, mapGetters: aiChatMapGetters } = createNamespacedHelpers('aichat')
    export default {
        name: "ChatWizard",
        components: {
            ChatLanguageSelection,
            ChatFaqSelection,
            ChatVersionSelection,
            ChatIndexingState
        },
        computed: {
            ...aiChatMapGetters([
                'getItem'
            ]),
            showNextButton() {
                const step = this.getItem('wizardStep');
                return step !== 'faq-selection' && step !== 'indexing-loading';
            },
            nextStep() {
                if (this.getItem('wizardStep') == 'version-selection' && this.getItem('versionId')) {
                    return 'language-selection';
                } else if (this.getItem('wizardStep') == 'language-selection' && this.getItem('itemId')) {
                    return 'after-language';
                } else {
                    return '';
                }
            }
        },
        methods: {
            ...aiChatMapActions([
                'setItem',
                'continueAfterLanguageSelection'
            ]),
            handleNextClick() {
                if (!this.nextStep) {
                    return;
                }
                if (this.nextStep === 'after-language') {
                    this.continueAfterLanguageSelection();
                    return;
                }
                this.setItem({field: 'wizardStep', value: this.nextStep});
            }
        }
    }
</script>
